<template>
    <table class="tx-details-table">
        <tbody>
            <!--<div v-if="!txDetails" class="skeleton skeleton&#45;&#45;inline">from address1 to address2</div>-->
            <template v-if="isTxSimple && txDetails?.event === 'jetton_swap'">
                <tr>
                    <td class="tx-details-table__left">{{ $t('address.all_tx_table.from') }}</td>
                    <td><ui-address style="max-width: 210px" v-bind:address="txDetails.from" v-bind:alias="txDetails?.source_alias" /></td>
                </tr>
                <tr>
                    <td class="tx-details-table__left">{{ $t('dex_table.dex') }}</td>
                    <td>
                        <a v-if="txDetails.dex === 'dedust'" href="https://dedust.io/" target="_blank">DeDust.io</a>
                        <span v-else-if="txDetails.dex === 'tonco'">TONCO</span>
                        <span v-else-if="txDetails.dex === 'stonfi' || txDetails.dex === 'stonfi_v1' || txDetails.dex === 'stonfi_v2'">StonFi</span>
                        <span v-else>{{ txDetails.dex }}</span>
                    </td>
                </tr>
                <tr>
                    <td class="tx-details-table__left">{{ $t('dex_table.rate') }}</td>
                    <td>
                        1 {{ swapTickerOut }} &approx; {{ swapRate }} {{ swapTickerIn }}
                    </td>
                </tr>
            </template>
            <template v-else-if="isTxSimple">
                <tr>
                    <td class="tx-details-table__left">{{ $t('address.all_tx_table.from') }}</td>
                    <td>
                        <!-- Exception for nft purchase event, when sender is undefined -->
                        <div style="text-transform: capitalize" v-if="txDetails?.event === 'nft_purchase' && !txDetails.from && txDetails?.meta?.marketplace">
                            <ui-address v-if="txDetails.meta.marketplace === 'fragment'" address="UQBAjaOyi2wGWlk-EDkSabqqnF-MrrwMadnwqrurKpkla4QB" />
                            <span v-else>{{ txDetails.meta.marketplace }}</span>
                        </div>
                        <ui-address v-else style="max-width: 210px" v-bind:address="txDetails.from" v-bind:alias="txDetails?.source_alias" />
                    </td>
                </tr>
                <tr>
                    <td class="tx-details-table__left">{{ $t('address.all_tx_table.to') }}</td>
                    <td><ui-address style="max-width: 210px" v-bind:address="txDetails.to" v-bind:alias="txDetails?.destination_alias" /></td>
                </tr>
            </template>
            <tr v-if="isTickTock">
                <td class="tx-details-table__left">{{ $t('dex_table.type') }}</td>
                <td>{{ $t('tx.service_tx') }}</td>
            </tr>
            <tr v-if="txDetails?.event === 'nft_purchase' && txDetails?.meta?.marketplace">
                <td class="tx-details-table__left">{{ $t('nft_sale.marketplace') }}</td>
                <td style="text-transform: capitalize">
                    <ui-address v-if="txDetails.meta.marketplace === 'fragment'" address="UQBAjaOyi2wGWlk-EDkSabqqnF-MrrwMadnwqrurKpkla4QB" />
                    <span v-else>{{ txDetails.meta.marketplace }}</span>
                </td>
            </tr>
            <tr>
                <td class="tx-details-table__left">{{ $t('tx.hash') }}</td>
                <td>
                    <div v-if="!hash" class="skeleton">Hash</div>
                    <ui-copy-button v-else v-bind:copy="hash">
                        {{ shortenHash }}...
                    </ui-copy-button>
                </td>
            </tr>
            <tr>
                <td class="tx-details-table__left">{{ $t('common.date') }}</td>
                <td>
                    <div v-if="!date" class="skeleton" style="width: 140px">Date</div>
                    <div v-else>
                        {{ date }} <span v-if="duration" class="muted">— {{ $t('tx.in_duration') }} <ui-date-period v-bind:seconds="duration" /></span>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { truncateTicker } from '~/helpers';

export default {
    methods: { truncateTicker },
    props: ['traceActions', 'date', 'hash', 'isTxSimple', 'isTickTock', 'duration'],
    computed: {
        swapTickerOut() {
            if (this.txDetails.meta.jetton_out_address === 'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez') {
                return 'TON';
            }
            return truncateTicker(this.txDetails.meta.symbol_out) || 'TON';
        },
        swapTickerIn() {
            if (this.txDetails.meta.jetton_in_address === 'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez') {
                return 'TON';
            }
            return truncateTicker(this.txDetails.meta.symbol_in) || 'TON';
        },
        swapRate() {
            const decimalsIn = Number.isInteger(this.txDetails.meta.decimals_in) ? this.txDetails.meta.decimals_in : 9;
            const decimalsOut = Number.isInteger(this.txDetails.meta.decimals_out) ? this.txDetails.meta.decimals_out : 9;

            const left = this.txDetails.meta.amount_in / 10 ** decimalsIn;
            const right = this.txDetails.meta.amount_out / 10 ** decimalsOut;

            return (left / right).toFixed(6);
        },
        txDetails() {
            if (!this.traceActions) return null;
            // const actionsAmount = this.traceActions.length;

            if (this.traceActions[0]?.simple_preview) {
                return this.traceActions[0]?.simple_preview;
            }
            return this.traceActions[0];
        },
        shortenHash() {
            return this.hash.slice(0, 24);
        },
    },
};
</script>

<style lang="scss">
.tx-details-table {
    margin-top: 8px;
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid var(--card-border-color);

    td {
        white-space: nowrap;
        padding: 8px 12px;
        border-bottom: 1px solid var(--card-border-color);
    }

    tr:last-child {
        td {
            border-bottom: none;
        }
    }

    &__left {
        text-transform: capitalize;
        background: var(--code-viewer-tab-inactive-background);
        border-right: 1px solid var(--card-border-color);
    }
}

.mobile-tx-address-list {
    width: 100%;
    text-align: center;
    padding: 6px 0 0 0;
    p {
        margin: 8px 0;
        padding: 0;
    }
}
</style>
